import type { SandboxPromptSchemaProps } from '@/schemas/sandboxPrompts/schema';
import service from './service';
import type { HttpResponseSuccess, HttpResponseError } from './service';

const apiService = service(`${process.env.REACT_BACKEND_HOST}`);

export type PostSandboxPromptResponse =
	HttpResponseSuccess<SandboxPromptSchemaProps>;

export const getSandboxPrompts = () =>
	apiService.get<
		HttpResponseSuccess<Array<SandboxPromptSchemaProps>>,
		HttpResponseError
	>('/api/sandbox-prompts');

export const createSandboxPrompt = (data: SandboxPromptSchemaProps) =>
	apiService.post<PostSandboxPromptResponse, HttpResponseError>(
		'/api/sandbox-prompts',
		data
	);

export type UpdateSandboxPromptProps = {
	promptId: string;
	data: SandboxPromptSchemaProps;
};

export const updateSandboxPrompt = ({
	data,
	promptId
}: UpdateSandboxPromptProps) =>
	apiService.put<PostSandboxPromptResponse, HttpResponseError>(
		`/api/sandbox-prompts/${promptId}`,
		data
	);

export type ActivateDefaultPromptProps = {
	type: SandboxPromptSchemaProps['type'];
};

export const activateDefaultPrompt = ({ type }: ActivateDefaultPromptProps) =>
	apiService.post<PostSandboxPromptResponse, HttpResponseError>(
		'/api/sandbox-prompts/default/activate',
		{ type }
	);
